import React, { useEffect, useState } from "react"
import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Grid,
  Input,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from "@mui/material"
import * as Style from "./style"
import moment from "moment"

import { IoCamera } from "react-icons/io5"
import { useNavigate } from "react-router-dom"
import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import * as yup from "yup"
import {
  useAccountProfileQuery,
  useAccountUpdateMutation,
  useGetCountrysQuery,
  useGetServiceProvierQuery,
} from "../../features/Auth/authApi"
import { toast } from "react-toastify"
import dummy from "../../images/dummy-image.jpg"
import CenteredSpinner from "../common/CenteredSpinner"
import LocationSelect from "../location/locationSelect"
import CropperModal from "../modals/CroperModal"

interface propsView {
  editView: boolean
  setEditView: (value: boolean) => void
}
interface EditAccountUser {
  name: string
  email: string
  contactNo: string
  services: (string | undefined)[]
  region: string
  gender: string

  language: (string | undefined)[]
  dob: string
  description: string
}

const EditAccount = ({ editView, setEditView }: propsView) => {
  const [previewImage, setPreviewImage] = useState(null)
  const [fileUpload, setFileUpload] = useState<File | null>(null)
  const [loactionSearchData, setLocationSearchData] = useState<string>("")
  const [errorMsg, setErrorMsg] = useState<string>()
  const [open, setOpen] = React.useState(false)
  const [cropperOpen, setCropperOpen] = useState(false)
  const [imageToCrop, setImageToCrop] = useState<{
    imageSrc: string
    extension: string
  }>({ imageSrc: "", extension: "png" })
  const { data: serviceProvider } = useGetServiceProvierQuery({})
  const { data: countrySelect } = useGetCountrysQuery({})
  const { data: getProfile, isFetching, isLoading } = useAccountProfileQuery({})
  const [userDetails, setuserDetails] = useState([])
  const [isLoadinga, setIsLoadinga] = useState(false)

  const navigate = useNavigate()
  const [
    accountUpdate,
    { data: updateData, error: errorAccount, isLoading: updateIsloading },
  ] = useAccountUpdateMutation()

  const onChnage = (e: any) => {
    const file = e.target.files[0]

    if (file) {
      const maxSize = 5 * 1024 * 1024
      if (file.size > maxSize) {
        toast.error("File Size Exceeds 5MB. Please Select A Smaller File.", {
          autoClose: 1000,
        })
        return
      }

      if (!["image/jpeg", "image/png"].includes(file.type)) {
        toast.error(
          "Unsupported File Type. Please Select An Image File (JPEG or PNG).",
          { autoClose: 1000 },
        )
        return
      }

      const extension = file.name.split(".").pop().toLowerCase()
      const reader = new FileReader()
      reader.onloadend = () => {
        setImageToCrop({
          imageSrc: reader.result as string,
          extension: extension,
        })
        setCropperOpen(true)
      }
      reader.readAsDataURL(file)
    }
  }

  const handleCroppedImage = (file: File) => {
    setFileUpload(file)
    const reader = new FileReader()
    reader.onloadend = () => {
      setPreviewImage(reader.result as any)
    }
    reader.readAsDataURL(file)
    setCropperOpen(false)
  }
  const schemaResolver = yup.object().shape({
    name: yup.string().required("Please Enter First Name"),
    email: yup.string().email().required("Please Enter An Email"),
    contactNo: yup
      .string()
      .required("Please Enter Phone Number")
      .matches(/^(1\s?)?[2-9]\d{2}[2-9]\d{6}$/, "Please Enter A Valid Canadian Phone Number (e.g. 604XXXXXXX)")
      .test(
        "Not-All-Zeros",
        "Please Enter A Valid Phone Number.",
        (value) => value !== undefined && !/^0+$/.test(value),
      ),
    services: yup
      .array()
      .of(yup.string())
      .min(1, "Please Select At Least One Services")
      .required("Please Enter Services"),
    region: yup.string().required("Please Enter Country"),
    gender: yup.string().required("Please Enter Gender"),
    language: yup
      .array()
      .of(yup.string())
      .min(1, "Please Select At Least One Language")
      .max(3, "Please Select Up To 3 Languages")
      .required("Please Enter Language"),
    // location: yup.string().required("Please enter address"),
    dob: yup
      .string()
      .required("Please Enter Your Date Of Birth")
      .test("Age", "Age Must Be 18 Years Or Older", function (value) {
        if (!value) return false
        const selectedDate = new Date(value)
        const currentDate = new Date()
        let age = currentDate.getFullYear() - selectedDate.getFullYear()
        const monthDiff = currentDate.getMonth() - selectedDate.getMonth()
        if (
          monthDiff < 0 ||
          (monthDiff === 0 && currentDate.getDate() < selectedDate.getDate())
        ) {
          age--
        }
        return age >= 18
      }),

    description: yup
      .string()
      .required("Please Enter Your Bio.")
      .min(10, "Bio Must Be At Least 10 Characters.")
      .max(500, "Bio Should Be Maximum 500 Characters"),
  })

  const {
    register,
    handleSubmit,
    watch,
    formState: { errors },
    setValue,
  } = useForm<EditAccountUser, any>({
    resolver: yupResolver(schemaResolver),
  })

  useEffect(() => {
    // Fetch services and languages data

    const fetchServicesAndLanguages = async () => {
      try {
        const servicesData = getProfile || []
        const array = servicesData?.data?.services?.map(
          (item: any) => item?._id,
        )
        const dob = servicesData?.data?.dob
        const formattedDate = dob ? moment(dob).format("YYYY-MM-DD") : null
        if (servicesData && servicesData.data) {
          setValue("name", servicesData?.data?.name)
          setValue("email", servicesData?.data?.email)
          setValue("contactNo", servicesData?.data?.contactNo)
          setLocationSearchData(servicesData?.data?.address)

          setValue("language" as any, servicesData?.data?.language as any)

          setValue("region" as any, servicesData?.data?.region as any)
          setValue("services" as any, (array as any) || "")
          setValue("description", servicesData?.data?.description)
          setValue("gender", servicesData?.data?.gender)
          setValue("dob" as any, formattedDate)
        }
      } catch (error) {
        console.error("Error fetching user profile:", error)
      } finally {
        setIsLoadinga(false)
      }
    }

    fetchServicesAndLanguages()
  }, [getProfile, setValue])

  const onSubmit = (data: any) => {
    const formData = new FormData()

    formData.append("name", data?.name)
    formData.append("email", data?.email)
    formData.append("contactNo", data?.contactNo)

    formData.append("address", loactionSearchData || "")
    formData.append("language", data?.language)
    formData.append("dob", data?.dob)
    formData.append("region", data?.region)
    formData.append("description", data?.description)
    formData.append("services", data?.services)

    if (fileUpload) {
      formData.append("profilePic", fileUpload)
    } else if (data?.gender) {
      formData.append("gender", data?.gender)
    }

    if (loactionSearchData !== "") {
      accountUpdate(formData)
    } else {
      setErrorMsg("Please enter address")
    }
  }

  useEffect(() => {
    if (updateData?.message) {
      toast.success(updateData?.message)
      setEditView(!editView)
    } else {
      toast.error((errorAccount as any)?.data?.message)
    }
  }, [updateData, errorAccount])

  return (
    <>
      {isLoading ? (
        <Typography fontSize={1}>
          <CenteredSpinner />
        </Typography>
      ) : (
        <Style.Overview>
          <Grid container>
            <Grid xs={12} className="ps-0">
              <Box className="review-card p-4">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Grid container className="mb-2">
                    <Grid xs={12} md={4} style={{ margin: "auto" }}>
                      <Typography variant="body1">
                        Change Profile Photo
                      </Typography>
                    </Grid>
                    <Grid xs={12} md={8} className="text-start">
                      <Box className="d-inline-block position-relative ">
                        <label
                          htmlFor="upload-profile-pic"
                          className="upload-label"
                        >
                          <img
                            src={
                              previewImage || getProfile?.data?.profilePic
                                ? previewImage || getProfile?.data?.profilePic
                                : dummy
                            }
                            className="profile-img"
                          />
                          <span
                            style={{
                              position: "absolute",
                              backgroundColor: "#fdaf18",
                              borderRadius: "50%",
                              padding: "3px",
                              width: "25px",
                              height: "25px",
                              bottom: "-5px",
                              right: "-10px",
                              border: "2px solid #fff",
                              display: "flex",
                              color: "#fff",
                            }}
                          >
                            <IoCamera />
                          </span>
                        </label>
                        <input
                          type="file"
                          id="upload-profile-pic"
                          className="d-none"
                          onChange={onChnage}
                          accept=".jpg,.png,.jpeg"
                        />
                      </Box>
                    </Grid>
                  </Grid>
                  <Grid container className="mt-4">
                    <Grid xs={12} md={4}>
                      <Typography variant="body1">Name</Typography>
                    </Grid>
                    <Grid
                      xs={12}
                      md={8}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#C1C1C1", // default
                          },
                          "&:hover fieldset": {
                            borderColor: "#f07fa9 !important", // hover
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#f07fa9 !important", // focus
                          },
                          "&.Mui-active fieldset": {
                            borderColor: "#f07fa9 !important", // active
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          padding: "4px !important",
                        },
                      }}
                    >
                      <OutlinedInput
                        placeholder="Name"
                        className="feature-field feature-field-bordered font-16"
                        fullWidth
                        {...register("name")}
                      />
                      <p className="text-danger">{errors.name?.message}</p>
                    </Grid>
                  </Grid>
                  <Grid container className="my-2">
                    <Grid xs={12} md={4}>
                      <Typography variant="body1">E-Mail</Typography>
                    </Grid>
                    <Grid xs={12} md={8}>
                      <Input
                        placeholder="Email"
                        disabled
                        className="feature-field icon-field font-16"
                        fullWidth
                        {...register("email")}
                        startAdornment={
                          <InputAdornment position="start"></InputAdornment>
                        }
                      />
                      <p className="text-danger">{errors.email?.message}</p>
                    </Grid>
                  </Grid>
                  <Grid container className="mb-2">
                    <Grid xs={12} md={4}>
                      <Typography variant="body1">Phone Number</Typography>
                    </Grid>
                    <Grid xs={12} md={8}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#C1C1C1", // default border
                          },
                          "&:hover fieldset": {
                            borderColor: "#f07fa9 !important", // hover
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#f07fa9 !important", // focus
                          },
                          "&.Mui-active fieldset": {
                            borderColor: "#f07fa9 !important", // active
                          },
                        },
                      }}>
                      <OutlinedInput
                        type="text"
                        inputMode="numeric"
                        placeholder="Phone Number"
                        className="phone-field icon-field"
                        fullWidth
                        {...register("contactNo")}
                        onKeyPress={(event) => {
                          const keyCode = event.keyCode || event.which
                          const keyValue = String.fromCharCode(keyCode)
                          const numericRegex = /^[0-9]+$/

                          if (!numericRegex.test(keyValue)) {
                            event.preventDefault()
                          }
                        }}
                        startAdornment={
                          <InputAdornment position="start"></InputAdornment>
                        }
                        sx={{
                          "& .MuiOutlinedInput-input": {
                            padding: "12px 4px !important",
                          },
                        }}
                      />
                      <p className="text-danger">{errors.contactNo?.message}</p>
                    </Grid>
                  </Grid>

                  <Grid container className="mb-2">
                    <Grid xs={12} md={4}>
                      <Typography variant="body1">Gender</Typography>
                    </Grid>
                    <Grid
                      xs={12}
                      md={8}
                      sx={{
                        "& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":
                        {
                          padding: "4px!important",
                        },
                        "& .css-qiwgdb.css-qiwgdb.css-qiwgdb": {
                          padding: "4px!important",
                        },
                      }}
                    >
                      <Select
                        placeholder="Gender"
                        value={watch("gender" as any) || []}
                        disabled
                        className="feature-field font-16 border-0"
                        {...register("gender" as any)}
                        onChange={(event) => {
                          const selectedGender = event.target.value
                          setValue("gender" as any, selectedGender as any, {
                            shouldValidate: true,
                          })
                        }}
                        fullWidth
                      >
                        <MenuItem value="Male">Male</MenuItem>
                        <MenuItem value="Female">Female</MenuItem>
                        <MenuItem value="Other">Other</MenuItem>
                      </Select>
                      <p className="text-danger">
                        {(errors as any)?.gender?.message}
                      </p>
                    </Grid>
                  </Grid>
                  <Grid container className="mb-2">
                    <Grid xs={12} md={4}>
                      <Typography variant="body1">Language</Typography>
                    </Grid>
                    <Grid
                      xs={12}
                      md={8}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#C1C1C1", // default
                          },
                          "&:hover fieldset": {
                            borderColor: "#f07fa9 !important", // hover
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#f07fa9 !important", // focus
                          },
                          "&.Mui-active fieldset": {
                            borderColor: "#f07fa9 !important", // active
                          },
                        },
                        "& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":
                        {
                          padding: "4px!important",
                        },
                        "& .css-qiwgdb.css-qiwgdb.css-qiwgdb": {
                          padding: "4px!important",
                        },
                      }}
                    >
                      <Select
                        labelId="demo-simple-select-label"
                        className="feature-field font-16 border-0"
                        multiple
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 250,
                              width: 150,
                              overflowY: "auto",
                              scrollbarWidth: "thin",
                              scrollbarColor: "#f07fa9 transparent",
                              borderRadius: "12px",
                              cursor: "pointer",
                            },
                          },
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                        }}
                        id="demo-simple-select"
                        {...register("language" as any)}
                        value={watch("language" as any) || []}
                        onChange={(event) => {
                          const selectedValues = event.target.value as string[]
                          setValue("language" as any, selectedValues as any, {
                            shouldValidate: true,
                          })
                        }}
                        onClose={() => setOpen(false)}
                        open={open}
                        onClick={() => setOpen(!open)}
                        renderValue={(selected) => (
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 0.5,
                            }}
                          >
                            {selected.map((value: any) => (
                              <Chip
                                key={value}
                                label={value}
                                onDelete={() => {
                                  const newValues = (
                                    watch("language" as any) || []
                                  ).filter((lang: any) => lang !== value)
                                  setValue("language" as any, newValues, {
                                    shouldValidate: true,
                                  })
                                }}
                                onMouseDown={(event) => {
                                  // Prevent the select from opening when clicking on chips
                                  event.stopPropagation()
                                }}
                              />
                            ))}
                          </Box>
                        )}
                        fullWidth
                      >
                        {countrySelect?.languages?.map((item: any) => (
                          <MenuItem key={item.name} value={item.name}>
                            {item.name}
                          </MenuItem>
                        ))}
                      </Select>

                      <p className="text-danger">
                        {(errors as any).language?.message}
                      </p>
                    </Grid>
                  </Grid>
                  <Grid container className="mb-2">
                    <Grid xs={12} md={4}>
                      <Typography variant="body1">Date Of Birth</Typography>
                    </Grid>
                    <Grid xs={12} md={8}>
                      <Input
                        type="date"
                        placeholder="Age"
                        className="feature-field font-16"
                        fullWidth
                        {...register("dob" as any)}
                      />
                      <p className="text-danger">
                        {(errors as any).dob?.message}
                      </p>
                    </Grid>
                  </Grid>
                  <Grid container className="mb-2">
                    <Grid xs={12} md={4}>
                      <Typography variant="body1">Origin Country</Typography>
                    </Grid>
                    <Grid
                      xs={12}
                      md={8}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#C1C1C1", // default
                          },
                          "&:hover fieldset": {
                            borderColor: "#f07fa9 !important", // hover
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#f07fa9 !important", // focus 
                          },
                        },
                        "& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":
                        {
                          padding: "4px!important",
                        },
                        "& .css-qiwgdb.css-qiwgdb.css-qiwgdb": {
                          padding: "4px!important",
                        },
                      }}
                    >
                      <Select
                        placeholder="Origin country"
                        className="feature-field font-16 border-0"
                        {...register("region" as any)}
                        value={watch("region" as any) || []}
                        fullWidth
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 250,
                              width: 150,
                              overflowY: "auto",
                              scrollbarWidth: "thin",
                              scrollbarColor: "#f07fa9 transparent",
                              borderRadius: "12px",
                              cursor: "pointer",
                            },
                          },
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                        }}
                      >
                        {countrySelect?.countries?.map((item: any) => (
                          <MenuItem key={item?.name} value={item?.name}>
                            {item?.name}
                          </MenuItem>
                        ))}
                      </Select>

                      <p className="text-danger">{(errors as any).region?.message}</p>
                    </Grid>

                  </Grid>
                  <Grid container className="mb-2">
                    <Grid xs={12} md={4}>
                      <Typography variant="body1">Location</Typography>
                    </Grid>
                    <Grid
                      xs={12}
                      md={8}
                      mt={1}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: "10px!important",
                        },
                        "& .css-fedopx-MuiStack-root": {
                          width: "100%",
                        },
                      }}
                    >
                      <LocationSelect
                        placeholder="Enter Location"
                        setLocationSearchData={setLocationSearchData}
                        setErrorMsg={setErrorMsg}
                        loactionSearchData={loactionSearchData}
                      />

                      <p className="text-danger">{errorMsg}</p>
                    </Grid>
                  </Grid>
                  {/* <Grid container className="mb-2">
                    <Grid xs={12} md={4}>
                      <Typography variant="body1">
                        Services Providing
                      </Typography>
                    </Grid>

                    <Grid
                      xs={12}
                      md={8}
                      className="custom-field"
                      sx={{
                        "& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":
                          {
                            padding: "4px!important",
                          },
                        "& .css-qiwgdb.css-qiwgdb.css-qiwgdb": {
                          padding: "4px!important",
                        },
                      }}
                    >
                      <InputLabel id="demo-simple-select-label"></InputLabel>
                      <Select
                        labelId="demo-simple-select-label"
                        className="feature-field font-16 border-0"
                        multiple
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 250,
                              width: 150,
                              overflowY: "auto",
                              scrollbarWidth: "thin",
                              scrollbarColor: "#f07fa9 transparent",
                              borderRadius: "12px",
                              cursor: "pointer",
                            },
                          },
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                        }}
                        id="demo-simple-select"
                        {...register("services" as any)}
                        value={watch("services" as any) || []}
                        onChange={(event) => {
                          const selectedValues = event.target.value
                          setValue("services" as any, selectedValues as any, {
                            shouldValidate: true,
                          })
                        }}
                        renderValue={(selected) => (
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 0.5,
                            }}
                          >
                            {selected.map((selectedItemId: any) => {
                              const selectedItem = serviceProvider?.data?.find(
                                (item: any) => item?._id === selectedItemId,
                              )
                              return (
                                <Chip
                                  key={selectedItemId}
                                  label={selectedItem?.name}
                                />
                              )
                            })}
                          </Box>
                        )}
                        fullWidth
                      >
                        {serviceProvider?.data?.map((item: any) => (
                          <MenuItem key={item?._id} value={item?._id}>
                            {item?.name}
                          </MenuItem>
                        ))}
                      </Select>

                      <p className="text-danger">
                        {(errors as any).services?.message}
                      </p>
                    </Grid>
                  </Grid> */}
                  <Grid container className="mb-4">
                    {" "}
                    {/* Increased margin bottom on Grid. */}
                    <Grid xs={12} md={4}>
                      <Typography variant="body1">
                        <strong></strong> Services Offered
                      </Typography>
                    </Grid>
                    <Grid
                      xs={12}
                      md={8}
                      className="custom-field"
                      sx={{
                        mb: 4, // Increased space under the dropdown field.
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#C1C1C1", // default
                          },
                          "&:hover fieldset": {
                            borderColor: "#f07fa9 !important", // hover
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#f07fa9 !important", // focus
                          },
                          "&.Mui-active fieldset": {
                            borderColor: "#f07fa9 !important", // active
                          },
                        },
                        "& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input":
                        {
                          padding: "4px!important",
                          whiteSpace: "normal",
                        },
                        "& .css-qiwgdb.css-qiwgdb.css-qiwgdb": {
                          padding: "4px!important",
                        },
                      }}
                    >
                      <InputLabel id="demo-simple-select-label"></InputLabel>

                      <Select
                        labelId="demo-simple-select-label"
                        className="feature-field font-16 border-0"
                        multiple
                        fullWidth
                        MenuProps={{
                          PaperProps: {
                            style: {
                              maxHeight: 250,
                              width: 150,
                              overflowY: "auto",
                              scrollbarWidth: "thin",
                              scrollbarColor: "#f07fa9 transparent",
                              borderRadius: "12px",
                              cursor: "pointer",
                            },
                          },
                          anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                          },
                          transformOrigin: {
                            vertical: "top",
                            horizontal: "left",
                          },
                        }}
                        id="demo-simple-select"
                        {...register("services" as any)}
                        value={watch("services" as any) || []}
                        onChange={(event) => {
                          const selectedValues = event.target.value
                          setValue("services" as any, selectedValues as any, {
                            shouldValidate: true,
                          })
                        }}
                        renderValue={(selected) => (
                          <Box
                            sx={{
                              display: "flex",
                              flexWrap: "wrap",
                              gap: 0.5,
                              mb: 2, // Increased margin below selected chips.
                            }}
                          >
                            {selected.map((selectedItemId: any) => {
                              const selectedItem = serviceProvider?.data?.find(
                                (item: any) => item?._id === selectedItemId,
                              )
                              return (
                                <Box
                                  key={selectedItemId}
                                  sx={{
                                    backgroundColor: "#e0e0e0",
                                    padding: "4px 8px",
                                    borderRadius: "16px",
                                    fontSize: "14px",
                                    maxWidth: 150,
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    lineHeight: 1.2,
                                  }}
                                >
                                  <strong></strong> {selectedItem?.name}
                                </Box>
                              )
                            })}
                          </Box>
                        )}
                      >
                        {serviceProvider?.data?.map((item: any) => (
                          <MenuItem
                            key={item?._id}
                            value={item?._id}
                            sx={{
                              whiteSpace: "normal",
                              wordBreak: "break-word",
                              lineHeight: 1.2,
                              py: 0.5,
                            }}
                          >
                            <strong></strong> {item?.name}
                          </MenuItem>
                        ))}
                      </Select>

                      <p className="text-danger">
                        {(errors as any).services?.message}.
                      </p>
                    </Grid>
                  </Grid>

                  <Grid container className="mb-2">
                    <Grid xs={12} md={4}>
                      <Typography variant="body1">Your Bio</Typography>
                    </Grid>
                    <Grid xs={12} md={8}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          "& fieldset": {
                            borderColor: "#C1C1C1", // default
                          },
                          "&:hover fieldset": {
                            borderColor: "#f07fa9 !important", // hover
                          },
                          "&.Mui-focused fieldset": {
                            borderColor: "#f07fa9 !important", // focus
                          },
                          "&.Mui-active fieldset": {
                            borderColor: "#f07fa9 !important", // active
                          },
                        },
                        "& .MuiOutlinedInput-input": {
                          padding: "4px !important",
                        },
                      }}>
                      <OutlinedInput
                        placeholder="Bio"
                        className="feature-field feature-field-bordered font-16 "
                        fullWidth
                        {...register("description" as any)}
                      />
                      <p className="text-danger">
                        {(errors as any).description?.message}
                      </p>
                    </Grid>
                  </Grid>

                  <Grid container className="mb-2">
                    <Grid md={12}>
                      <Box className="text-end">
                        <Button
                          className="view-profile text-capitalize"
                          type="submit"
                        >
                          {updateIsloading ? (
                            <>
                              <Typography fontSize={1}>
                                <CircularProgress
                                  style={{ color: "pink" }}
                                  size={20}
                                />
                              </Typography>
                            </>
                          ) : (
                            "Save"
                          )}
                        </Button>
                      </Box>
                    </Grid>
                  </Grid>
                </form>
              </Box>
            </Grid>
          </Grid>

          <CropperModal
            open={cropperOpen}
            onClose={() => setCropperOpen(false)}
            level={1}
            data={imageToCrop}
            setResults={handleCroppedImage}
          />
        </Style.Overview>
      )}
    </>
  )
}
export default EditAccount
